import { resolveComponent as _resolveComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "alp-multiText" }
const _hoisted_2 = { class: "multiTextEditView" }
const _hoisted_3 = { class: "list" }
const _hoisted_4 = { class: "idx" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "btn" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_11 = { class: "moreBtn" }

export function render(_ctx: any,_cache: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_UpOutlined = _resolveComponent("UpOutlined")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_EllipsisOutlined = _resolveComponent("EllipsisOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_input, _mergeProps({
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled
    }, _ctx.a_attr, _toHandlers(_ctx.a_event), {
      onPaste: _ctx.multiTextPaste,
      onKeyup: _ctx.multiTextInputEnter,
      value: _ctx.multiText,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.multiText) = $event))
    }), null, 16, ["placeholder", "disabled", "onPaste", "onKeyup", "value"]),
    _createVNode(_component_a_popover, {
      placement: "bottomRight",
      trigger: "click",
      visible: _ctx.multiTextPopup.show,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.multiTextPopup.show) = $event)),
      overlayClassName: "multiTextEditPopup",
      onVisibleChange: _ctx.multiTextPopupOpen
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.multiTextPopup.showData, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row",
                key: item.idx
              }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(item.idx), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_a_input, {
                    value: _ctx.multiTextPopup.showData[idx].value,
                    "onUpdate:value": ($event: any) => ((_ctx.multiTextPopup.showData[idx].value) = $event),
                    clearable: "",
                    size: "small"
                  }, null, 8, ["value", "onUpdate:value"])
                ]),
                _createElementVNode("div", {
                  class: "removeBtn",
                  onClick: ($event: any) => (_ctx.multiTextPopupOptions('row:delete', item.idx))
                }, [
                  _createVNode(_component_DeleteOutlined)
                ], 8, _hoisted_6)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, "共 " + _toDisplayString(_ctx.multiTextPopup.data.length) + " 条", 1),
            _createElementVNode("span", {
              class: "up",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.multiTextPage('up')))
            }, [
              _createVNode(_component_UpOutlined)
            ]),
            _createElementVNode("span", {
              class: "down",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.multiTextPage('down')))
            }, [
              _createVNode(_component_DownOutlined)
            ]),
            _createVNode(_component_a_button, {
              type: "text",
              size: "small",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.multiTextPopupOptions('clearAll')))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "text",
              size: "small",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.multiTextPopupOptions('add')))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "text",
              size: "small",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.multiTextPopupOptions('submit')))
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_EllipsisOutlined)
        ])
      ]),
      _: 1
    }, 8, ["visible", "onVisibleChange"])
  ]))
}